import React from 'react';
import { DatePicker } from '@atlassian/jira-portfolio-3-common';
import type { Props } from '@atlassian/jira-portfolio-3-common/src/date-picker/types';

export default function FieldDatePicker({ ...props }: Props) {
	return <DatePicker {...props} />;
}
